<template>
    <div v-if="projectWithRouter" class="automation-will-send-emails">
        <div v-for="(item, index) in automationsWillSendEmails" :key="index">
            <div :id="'automationsWillSendEmails_' + item.automationsWillSendEmailsKey">
                Sending automated emails...<br/>
                <a @click="dontSend(item.automationsWillSendEmailsKey)">Don't Send</a> <a @click="showDetails(item.automationsWillSendEmailsKey, item.automationsWillSendEmailsList)">See Details</a>
            </div>
        </div>
    </div>
</template>

<script>

import { defineAsyncComponent } from "vue";
import { sDs } from '@common/sDs/sDs';
import { library } from "@common/library/library";

let automationWillSendEmailsCmp = {
    name: 'automationWillSendEmails',
    props: {},
    data() {
        return {};
    },
    computed: {
        navigationStore() {
            return typeof navigationStore === 'function' ? navigationStore() : {};
        },
        projectWithRouter() {
            return this.navigationStore?.projectWithRouter || false;
        },
        automationsWillSendEmails() {
            return this.navigationStore?.automationsWillSendEmails || [];
        }
    },
    methods: {
        dontSend(automationsWillSendEmailsKey) {
            sDs.post('ec_automationProcessEmails', automationsWillSendEmailsKey, []);
        },
        showDetails(automationsWillSendEmailsKey, automationsWillSendEmailsList) {
            let items = [];
            let defaultValue = {};
            for (let i in automationsWillSendEmailsList) {
                defaultValue[automationsWillSendEmailsList[i].id] = true;
                items.push({
                    text: automationsWillSendEmailsList[i].name,
                    value: automationsWillSendEmailsList[i].id,
                    selected: true
                });
            }
            let dialogComponentId = 'automationsWillSendEmailsDetails_' + library.getUniqueID();
            let selectedEmails = {};
            let componentDialogTemplate = {
                name: dialogComponentId,
                template: `<div class="automation-will-send-emails-details">
                    <control name="SELECTED_EMAILS" :prop-config="controlConfig" @update:value="change($event)"></control>
                </div>`,
                data() {
                    return {
                        controlConfig: {
                            name: 'SELECTED_EMAILS',
                            type: 'CHECKBOX_LIST',
                            label: 'Please select from the list below which emails should be sent along with this profile update:',
                            items: items,
                            default: defaultValue
                        }
                    };
                },
                methods: {
                    change(value) {
                        selectedEmails = value;
                    }
                },
                components: {
                    control: defineAsyncComponent(() => import('@common/control/control.vue'))
                }
            };
            let defaultDialogSettings = {
                name: dialogComponentId,
                isComponentDialog: true,
                okButtonLabel: 'Save and Send Email',
                cancelButtonLabel: 'Save but don\'t Send'
            };
            library.showDialog(componentDialogTemplate, () => {
                let sendEmails = [];
                for (let i in selectedEmails) {
                    if (selectedEmails[i]) sendEmails.push(i);
                }
                sDs.post('ec_automationProcessEmails', automationsWillSendEmailsKey, sendEmails);
            }, () => {
                sDs.post('ec_automationProcessEmails', automationsWillSendEmailsKey, []);
            }, defaultDialogSettings);
        }
    },
    watch: {
        'automationsWillSendEmails': function () {
            for (let i in this.automationsWillSendEmails) {
                if (
                    this.automationsWillSendEmails[i].automationsWillSendEmailsKey
                    && Array.isArray(this.automationsWillSendEmails[i].automationsWillSendEmailsList)
                    && this.automationsWillSendEmails[i].automationsWillSendEmailsList.length
                    && !library.getToast('automationsWillSendEmails_' + this.automationsWillSendEmails[i].automationsWillSendEmailsKey)
                ) {
                    library.showToast(false, {
                        name: 'automationsWillSendEmails_' + this.automationsWillSendEmails[i].automationsWillSendEmailsKey,
                        templateElemId: document.getElementById('#automationsWillSendEmails_' + this.automationsWillSendEmails[i].automationsWillSendEmailsKey),
                        timeout: 60,
                        showProgressBar: true
                    });
                }
            }
        },
    },
    components: {}
};

export { automationWillSendEmailsCmp };
export default automationWillSendEmailsCmp;
</script>

<style scoped>
:deep(.automation-will-send-emails) {
    display: none;
}
</style>

<style>
.automation-will-send-emails-details .label-text {
    font-size: 13px;
    font-weight: normal;
}
</style>
